(function ($) {
    let navigationHistory = [];

    let slideToRemoveAfterChange = null;

    const natureTitles = {
        'nature-hyperénergie': 'Hyperénergique',
        'nature-hypoénergie': 'Hypoénergique',
        'nature-hyperénergie-dystonie': 'Hyperénergique dystonique',
        'nature-hypoénergie-dystonie': 'Hypoénergique dystonique',
        'nature-hyperénergie-anergie': 'Hyperénergique anergique',
        'nature-hypoénergie-anergie': 'Hypoénergique anergique',
        'nature-hyperénergie-désadaptation': 'Hyperénergique désadaptation',
        'nature-hypoénergie-désadaptation': 'Hypoénergique désadaptation'
    };

    function goToPrevQuestion() {
        const currentSlideIndex = $('.formulaire__nature').slick('slickCurrentSlide');
        if (navigationHistory.length > 0) {
            slideToRemoveAfterChange = currentSlideIndex;
            navigationHistory.pop();
            $('.formulaire__nature').slick('slickPrev');
        } else {
            if (currentSlideIndex > 0) {
                slideToRemoveAfterChange = currentSlideIndex;
                $('.formulaire__nature').slick('slickPrev');
            }
        }
    }  

    function goToNextQuestion(nextStep) {
        const $currentSlide = $('.carousel__item.slick-current');
        const currentStepId = $currentSlide.data('question-id');
        if (currentStepId) {
            navigationHistory.push(currentStepId);
        }

        if (!nextStep) {
            $('.formulaire__nature').slick('slickNext');
            return;
        }

        const $existingSlide = $('.formulaire__nature').find(`.carousel__item[data-question-id="${nextStep}"], .carousel__item.${nextStep}`);

        if ($existingSlide.length > 0) {
            $('.formulaire__nature').slick('slickGoTo', $existingSlide.first().index());
            return;
        }

        const $slideToAdd = $('#slides-bank').find(`.carousel__item.${nextStep}`).clone();

        if ($slideToAdd.length === 0) {
            console.warn(`Slide '${nextStep}' non trouvée dans la banque.`);
            return;
        }

        $('.formulaire__nature').slick('slickAdd', $slideToAdd);
        const newIndex = $('.formulaire__nature .carousel__item').length - 1;
        $('.formulaire__nature').slick('slickGoTo', newIndex);
    }

    function validateInput($slide) {
        const type = $slide.data('question-type');
    
        if (type === 'question_simple') {
            const $selected = $slide.find('.formulaire__answer.selected');
            if ($selected.length === 0) {
                alert("Merci de sélectionner une réponse.");
                return false;
            }
            
            const isAutreSelected = $selected.is('[data-specifique]');
            const $autreInputContainer = $slide.find('.other-input-container');
            
            if (isAutreSelected && $autreInputContainer.length) {
                const valeur = $autreInputContainer.find('input').val().trim();
                if (!valeur) {
                alert("Merci de préciser votre état.");
                return false;
                }
                $slide.attr('data-autre-valeur', valeur);
            }
        }
    
        return true;
    }  

    $(document).ready(function () {
        $('.formulaire__nature').slick({
            accessibility: true,
            autoplay: false,
            arrows: false,
            dots: false,
            draggable: false,
            infinite: false,
            mobileFirst: true,
            swipe: false,
            touchMove: false,
            adaptiveHeight: true,
            touchThreshold: 5,
            initialSlide: 0,
        });

        let firstTransitionDone = false;
        $('.formulaire__nature').on('afterChange', function(event, slick, currentSlide) {
          if (slideToRemoveAfterChange !== null) {
            $('.formulaire__nature').slick('slickRemove', slideToRemoveAfterChange);
            slideToRemoveAfterChange = null;
          }

          const $currentSlide = $(slick.$slides[currentSlide]);

          if (currentSlide === 1 && !firstTransitionDone) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'start_quizz_ta'
            });
            firstTransitionDone = true;
          }

          if ($currentSlide.hasClass('end')) {
            const natures = calculerNaturesDepuisReponses();
            afficherNaturesRecommandees(natures);
            const email = $('input[name="email"]').val();
            console.log('submit_quizz_ta EVENT ' + email);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'submit_quizz_ta',
              user_data: {
                email_address: email
              }
            });
          }
        });     

        $('.formulaire__nature').css('opacity', '1');

        $(document).on('click', '[data-action="slide-next"]', function (e) {
            const $btn = $(this);
            const $slide = $btn.closest('.carousel__item');

            if (!validateInput($slide)) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }

            const questionType = $btn.data('question-type');
            if (questionType === 'question_simple') {
                const $selected = $slide.find('.formulaire__answer.selected');
                if ($selected.length === 0) {
                alert("Merci de sélectionner une réponse.");
                return false;
                }
            
                const customAnswers = $selected.filter('[data-custom-answer]');
                let nextStep = $selected.data('next-slide') || $selected.find('[data-next-slide]').data('next-slide');
                if (!nextStep) nextStep = $btn.data('next-slide');
            
                const isAutreSelected = $selected.is('[data-specifique]');
                const $autreInputContainer = $slide.find('.other-input-container');

                if (isAutreSelected && $autreInputContainer.length && $autreInputContainer.is(':hidden')) {
                $slide.find('.formulaire-question').hide();
                $autreInputContainer.show();
                return false;
                }

                if (customAnswers.length > 1) {
                goToNextQuestion(nextStep);
                return;
                }
            
                if ($selected.length === 1 && $selected.is('[data-custom-answer]')) {
                    const message = customAnswers.data('custom-answer');
                    const $messageBox = $slide.find('.formulaire-custom-answer-message');
                
                    if ($messageBox.length) {
                        $slide.find('.formulaire-question').hide();
                        $messageBox.text(message).show();

                        setTimeout(() => {
                        goToNextQuestion(nextStep);
                        }, 2000);
                    } else {
                        goToNextQuestion(nextStep);
                    }
                
                    return;
                }
                goToNextQuestion(nextStep);
            } else {
                goToNextQuestion($btn.data('next-slide'));
            }
        });

        $(document).on('click', '.other-input-container [data-action="slide-next"]', function () {
        const $btn = $(this);
        const $slide = $btn.closest('.carousel__item');
        const $input = $slide.find('.other-input-container input');
        const valeur = $input.val().trim();
        
        if (!valeur) {
            alert("Merci de préciser votre état.");
            return;
        }
        
        $slide.attr('data-autre-valeur', valeur);
        
        $slide.find('.other-input-container').hide();
        $slide.find('.formulaire-question').show();
        goToNextQuestion($btn.data('next-slide'));
        });    

        $(document).on('click', '[data-action="slide-prev"]', function () {
        goToPrevQuestion();
        });

        $(document).on('click', '.formulaire__answer', function () {
            const $clickedAnswer = $(this);

            if ($clickedAnswer.hasClass('disabled')) {
                return;
            }

            const $answersList = $clickedAnswer.closest('.formulaire__answers_list');
            const isMultiple = $answersList.data('multiple-answers') === true || $answersList.data('multiple-answers') === 'true';

            if (!isMultiple) {
                $answersList.find('.formulaire__answer').removeClass('selected');
                $clickedAnswer.addClass('selected');
            } else {
                $clickedAnswer.toggleClass('selected');
            }

            // Récupérer les réponses sélectionnées
            const $selectedAnswers = $answersList.find('.formulaire__answer.selected');

            if ($selectedAnswers.length === 0) {
                // Réinitialiser : tout actif
                $answersList.find('.formulaire__answer').removeClass('disabled');
                return;
            }

            // Construire la liste des ensembles d'autorisations pour chaque sélection
            let allowedSets = [];

            $selectedAnswers.each(function () {
                const selfIndex = $(this).data('index');
                const allowedStr = $(this).data('allowed') || "";
                const allowed = new Set(allowedStr.split('|').filter(Boolean));
                allowed.add(selfIndex); // Toujours autoriser la réponse sélectionnée elle-même
                allowedSets.push(allowed);
            });

            // Calculer l'intersection des ensembles autorisés
            let intersection = allowedSets[0];
            for (let i = 1; i < allowedSets.length; i++) {
                intersection = new Set([...intersection].filter(x => allowedSets[i].has(x)));
            }

            // Désactiver celles hors intersection (hors sélection)
            $answersList.find('.formulaire__answer').each(function () {
                const $ans = $(this);
                const idx = $ans.data('index');

                if (!intersection.has(idx) && !$ans.hasClass('selected')) {
                    $ans.addClass('disabled');
                } else {
                    $ans.removeClass('disabled');
                }
            });
        });


        function calculerNaturesDepuisReponses() {
            const natureCounts = {};

            $('.formulaire__nature .formulaire__answer.selected').each(function () {
                const nom = $(this).data('nature');
                if (!nom) return;

                if (!natureCounts[nom]) {
                    natureCounts[nom] = 1;
                } else {
                    natureCounts[nom]++;
                }
            });

            const opposés = ['Hyperénergie', 'Hypoénergie'];
            const secondaires = ['Anergie', 'Dystonie', 'Désadaptation'];

            const sortedNatures = Object.entries(natureCounts)
                .map(([nom, count]) => ({ nom, count }))
                .sort((a, b) => b.count - a.count);

            if (sortedNatures.length === 0) return [];

            const opposéesPrésentes = sortedNatures.filter(n => opposés.includes(n.nom));

            const top1 = opposéesPrésentes[0];

            const top2 = sortedNatures.find(n =>
                secondaires.includes(n.nom) && Math.abs(n.count - top1.count) <= 3
            );

            if (top2) {
                return [top1, top2];
            }

            return [top1];
        }
    
        function afficherNaturesRecommandees(natures) {
            const $endSlide = $('.carousel__item.end');

            let key = '';

            if (natures.length === 2) {
                const nom1 = natures[0].nom.toLowerCase();
                const nom2 = natures[1].nom.toLowerCase();
                key = `nature-${nom1}-${nom2}`;
            } else if (natures.length === 1) {
                key = `nature-${natures[0].nom.toLowerCase()}`;
            } else {
                key = 'nature-indeterminee';
            }

            const titreNature = natureTitles[key];

            const $toDisplay = $endSlide.find(`.nature-result.${key}`);
            console.log($toDisplay);
            const $texteElement = $toDisplay.find('.h2');

            if ($toDisplay.length) {
                const email = $('input[name="email"]').val()?.trim();
                const prenom = $('input[name="prenom"]').val()?.trim();

                const html = `Bonjour, ${prenom || 'cher utilisateur'} !<br><br>Vous êtes de nature : <strong>${titreNature}</strong>.`;
                $texteElement.html(html);
                $toDisplay.css('display', 'flex');

                envoyerEvenementKlaviyo(email, prenom, titreNature);
            } else {
                console.warn(`Bloc non trouvé pour la clé: ${key}`);
                $endSlide.find('.nature-result.nature-indeterminee').css('display', 'block');
            }
        }


        function envoyerEvenementKlaviyo(email, prenom, nature) {
            const klaviyoPublicApiKey = 'Uu7pCy';

            const reponses = recupererQuestionsEtReponses();

            const payload = {
                token: klaviyoPublicApiKey,
                event: 'Bilan Nature Terminé',
                customer_properties: {
                    $email: email
                },
                properties: {
                    Nature: nature,
                    ...reponses
                }
            };

            const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
            const img = new Image();
            img.src = `https://a.klaviyo.com/api/track?data=${base64Payload}`;

            console.log('Événement Klaviyo Nature envoyé via pixel', img.src);

            mettreAJourProfilKlaviyoNature(email, nature, reponses);
        }

        function mettreAJourProfilKlaviyoNature(email, nature, reponses) {
            const klaviyoPublicApiKey = 'Uu7pCy';

            const payload = {
                token: klaviyoPublicApiKey,
                properties: {
                    $email: email,
                    Nature: nature,
                    ...reponses
                }
            };

            const base64Payload = btoa(unescape(encodeURIComponent(JSON.stringify(payload))));
            const img = new Image();
            img.src = `https://a.klaviyo.com/api/identify?data=${base64Payload}`;

            console.log('Profil Klaviyo Nature mis à jour via pixel', img.src);
        }

        function recupererQuestionsEtReponses() {
            const reponses = {};

            $('.formulaire__nature .carousel__item').each(function () {
                const $slide = $(this);
                const questionTextRaw = $slide.find('.formulaire-question .question h2').text().trim();

                if (!questionTextRaw) return;

                const questionKey = "Bilan_Nature_" + supprimerAccents(questionTextRaw)
                    .replace(/-/g, '_')
                    .replace(/\s+/g, ' ')
                    .replace(/[?]/g, '')
                    .replace(/[^a-zA-Z0-9 ]/g, '')
                    .trim()
                    .replace(/\s/g, '_');

                const type = $slide.data('question-type');
                let reponsesQuestion = [];

                if (type === 'question_input_text' || type === 'question_input_date') {
                    const valeur = $slide.find('input').val();
                    if (valeur) {
                        reponsesQuestion.push(valeur.trim());
                    }
                } else if (type === 'question_simple') {
                    const $selected = $slide.find('.formulaire__answer.selected');
                    if ($selected.length === 0) return;

                    reponsesQuestion = $selected.map(function () {
                        if ($(this).is('[data-specifique]')) {
                            return $(this).text().trim() + ' - ' + ($slide.attr('data-autre-valeur') || '');
                        }
                        return $(this).text().trim();
                    }).get();
                }

                if (reponsesQuestion.length > 0) {
                    reponses[questionKey] = (reponsesQuestion.length === 1) ? reponsesQuestion[0] : reponsesQuestion;
                }
            });

            return reponses;
        }

        function supprimerAccents(texte) {
            return texte.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
    });
})(jQuery);